import { useBehavior, useTriggerAction } from '@libs/core';
import { ActionActionTypeEnum, TButtonData, TWidget, TWidgetProps } from '@libs/types';
import React from 'react';
import { TRowActionData } from '../../types/data';
import { TRowActionOption } from '../../types/options';
import { RowActionView } from './RowActionView';

/**
 * RowAction widget driven by server-provided configuration.
 * Owns behavior hooks (useBehavior, useTriggerAction) and delegates rendering to RowActionView.
 *
 * Use this component when the widget definition comes from the server and no
 * additional style overrides are required.
 */
export const RowActionWidget = ({ widget }: TWidgetProps<TRowActionData, TRowActionOption>) => {
    const { triggerActionsByType } = useTriggerAction(widget);
    const { isDisabled, isHidden } = useBehavior(widget as TWidget<TButtonData>);

    const title = widget.data?.messages?.title;
    const subtitle = widget.data?.messages?.subtitle;
    const helperText = widget.data?.messages?.helperText;
    const copiedText = widget.data?.messages?.copiedText;

    const isSubtitleTextPositionTop = (widget.options?.subtitleTextPosition ?? 'top') === 'top';
    const iconName = widget.options?.iconName ?? widget.data?.iconName;
    const parentStyleNames = [widget.options?.style].filter(Boolean) as string[];

    const onClickHandler = () => {
        triggerActionsByType(ActionActionTypeEnum.onClick, {
            playerActionOptions: {
                textForCopyToClipboard: title,
                toastMessage: copiedText,
            },
        }).then();
    };

    return (
        <RowActionView
            uid={widget.uid}
            widget={widget}
            isDisabled={isDisabled}
            isHide={isHidden}
            onClick={onClickHandler}
            title={title}
            subtitle={subtitle}
            helperText={helperText}
            iconName={iconName}
            isSubtitleTextPositionTop={isSubtitleTextPositionTop}
            parentStyleNames={parentStyleNames}
        />
    );
};
